import { useContext } from 'react';

import { KeycloakContext } from '../contexts';

export function useKeycloak() {
  return useContext(KeycloakContext);
}
